module.exports = require("./uz-Latn.d.ts");